class JvTabs extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      const tab = event.target.closest('.jv-tabbed__tab');
      if (!tab) return;
      const index = tab.dataset.tabIndex;
      this.querySelectorAll('.jv-tabbed__tab').forEach((el) => el.setAttribute('aria-selected', 'false'));
      tab.setAttribute('aria-selected', 'true');
      this.querySelectorAll('.jv-tabbed__panel').forEach((panel, i) => {
        panel.hidden = i != index;
      });
    });
  }
}

if (!customElements.get('jv-tabs')) {
  customElements.define('jv-tabs', JvTabs);
}
